import {Component} from 'react';
import PropTypes from 'prop-types';
import {Header} from 'semantic-ui-react';

export default class Disclaimers extends Component {
  static propTypes = {
    className: PropTypes.string,
    disclaimers: PropTypes.shape({
      clPublicationNz: PropTypes.string,
      clDataNz: PropTypes.string,
      titleNz: PropTypes.string
    }),
  };

  render() {
    const {className, disclaimers} = this.props;
    const classNames = ['title-disclaimers', className].join(' ').trim();
    return (
      <div className={classNames}>
        <Header as="h2">Title Disclaimers</Header>
        <p>{disclaimers.clPublicationNz}</p>
        <p>{disclaimers?.clDataNz?.replaceAll('<br>', '\n')}</p>
        <p>{disclaimers.titleNz}</p>
      </div>
    );
  }
}